(function () {
    "use strict";

    angular
        .module("app")
        .component("productUtilizationReportSearch", { // logged-in-home
            templateUrl: "src/app/reports/productUtilizationReport/productUtilizationReportSearch.html",
            controller: controller
        });

    function controller($window, $scope, $http, $filter, session, toast, $q, addressService, reportService) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.ui = {
            busy: {
                addresses: false,
                products: false,
                search: false
            }
        };
	    $ctrl.hasSearched = false;

        $ctrl.allShippingAddresses = [];
		$ctrl.selectedAddress = [];

	    const defaultCustomer = {
	        company_name: 'All Customers',
	        customer_id: null
	    };
	    $ctrl.customers = angular.copy($ctrl.session.user.customers);
	    $ctrl.customers.unshift(defaultCustomer);
	    $ctrl.selectedCustomer = defaultCustomer;
	    $ctrl.customerSelected = () => {
	        filterAddresses($ctrl.selectedCustomer.customer_id);
	        return loadProductsForSelectedCustomer();
	    };

		const anyAddress = { customer_id: null, contact_id: null, first_name: "All Addresses" };
		$ctrl.selectedAddress = anyAddress;

		$ctrl.productUtilizationReport = [];

        const now = moment();
        const thirtyDaysAgo = moment().subtract(30, "days");

        $ctrl.selected = {           
            ship_from_date: new Date(thirtyDaysAgo.format('MM/DD/YYYY')),
			ship_to_date: new Date(now.format('MM/DD/YYYY')),
			item_id: null
        };

	    // handle date changes
	    $scope.$watchCollection(() => ({
	            ship_from_date: $ctrl.selected.ship_from_date,
	            ship_to_date: $ctrl.selected.ship_to_date
	        }),
	        (newDates, oldDates) => {
	            if (newDates === oldDates) return;
	            if (moment(newDates.ship_from_date).isSame(oldDates.ship_from_date) && moment(newDates.ship_to_date).isSame(oldDates.ship_to_date)) return;

	            if (newDates.ship_from_date && newDates.ship_to_date)
	                loadAddresses();
	        });

        $ctrl.$onInit = () => {
			loadAddresses();
			loadProductsForSelectedCustomer();
        };

        function loadAddresses() {
            $ctrl.ui.busy.addresses = true;
			return addressService.getShippingByShipDate(null, $ctrl.selected.ship_from_date, $ctrl.selected.ship_to_date)
                .then(addresses => {
                    $ctrl.allShippingAddresses = addresses;
			        filterAddresses();
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy.addresses = false);
        }

        function filterAddresses(customerId) {
            if (!customerId) {
                $ctrl.shippingAddresses = angular.copy($ctrl.allShippingAddresses);
            } else {
                $ctrl.shippingAddresses = $ctrl.allShippingAddresses.filter(s => s.customer_id === customerId);
            }

            const defaultShippingAddress = {
                first_name: 'All Addresses',
                last_name: '',
                customer_id: null,
                contact_id: null
            };
            $ctrl.shippingAddresses.unshift(defaultShippingAddress);
			$ctrl.selectedAddress = defaultShippingAddress;
		}

		$ctrl.addressSelected = address => {
			$ctrl.selectedAddress = address;
		};


		//Prod functions-------------------------------------------------------------------------------------------------------------------------------------------------
		$ctrl.selectedProduct = null;
		$ctrl.products = [$ctrl.selectedProduct];
		$ctrl.productSelected = product => {
			$ctrl.selectedProduct = product;
			$ctrl.selected.item_id = product ? product.item_id : null;
		}

		function loadProductsForSelectedCustomer() {
		    $ctrl.ui.busy.products = true;
		    return session.products.getForCustomer($ctrl.selectedCustomer.customer_id)
				.then(products => {
					$ctrl.products = products;
		            $ctrl.productSelected(products.find(p => p.item_id === $ctrl.selected.item_id));
		            $ctrl.productSearchText = $ctrl.selectedProduct;
		        })
		        .finally(() => { $ctrl.ui.busy.products = false; });
		}

		$ctrl.isProductSearchTextValid = () => {
			return $ctrl.productSearchText == null || $ctrl.productSearchText.length === 0 || typeof $ctrl.productSearchText !== "string";
		}

		//---------- Search & Clear functions-----------------------------------------------------------------------------------------------------------------------------------------------   
	    $ctrl.canSearch = () => {
	        return $ctrl.selected.ship_from_date && $ctrl.selected.ship_to_date && !$ctrl.datesAreInvalid();
	    };

		$ctrl.search = () => {
		    $ctrl.ui.busy.search = true;
            $ctrl.hasSearched = false;
		    //$window.ga("send", "event", "ProductUtilReport", "productUtilReportClicked");
			const searchRequest = {
				customer_id: $ctrl.selectedCustomer.customer_id,
				pack_from_date: $ctrl.selected.ship_from_date,
				pack_to_date: $ctrl.selected.ship_to_date,
				contact_id: $ctrl.selectedAddress.shipping_contact_id,
				item_id: $ctrl.selected.item_id 
			}
		    return reportService.getProductUtilizationSearch(searchRequest)
                .then(productResult => {
		            console.log(productResult);
		            $ctrl.productUtilizationReport = productResult;
		        })
		        .catch(toast.errorHandler)
		        .finally(() => {
		            $ctrl.ui.busy.search = false;
		            $ctrl.hasSearched = true;
		        });
		};

        $ctrl.clear = () => {
            $ctrl.selectedCustomer = defaultCustomer;
            $ctrl.customerSelected().then(() => {
                $ctrl.productSelected(undefined);
                $ctrl.productSearchText = undefined;
            });
            $ctrl.selected.ship_from_date = new Date(thirtyDaysAgo.format('MM/DD/YYYY'));
            $ctrl.selected.ship_to_date = new Date(now.format('MM/DD/YYYY'));
			$ctrl.productUtilizationReport = [];
            $ctrl.hasSearched = false;
        };

		//----------Export Excel Function-----------------------------------------------------------------------------------------------------------------------------------------------   
		$ctrl.getExport = () => $ctrl.productUtilizationReport.map(pur => ({
			"CUSTOMER_ID": pur.customer_id,
			"COMPANY_NAME": pur.company_name,
			"ORDER_ID": pur.order_id,
            "ORDER_DATE": $filter("date")(pur.order_date, "MM/dd/yyyy"),
			"INVOICE_ID": pur.invoice_id,
            "INVOICE_DATE": $filter("date")(pur.invoice_date, "MM/dd/yyyy"),
			"PRODUCT_TYPE_ID": pur.product_type_id,
			"PRODUCT_DESCRIPTION": pur.product_description,
			"ITEM_ID": pur.item_id,
			"NDC_CODE": pur.NDC_Code,
			"ITEM_DESC": `${pur.item_desc || ''}`,
			"UNIT_COUNT": `${pur.unit_count || ''}`,
			"CASE_COUNT": `${pur.case_count || ''}`,
			"UNITS_PER_CASE": pur.units_per_case,
            "UNIT_PACK": pur.unit_pack_UOM_desc,
			"UNIT_PRICE": pur.unit_price,
            "PRIMARY_PACK": pur.primary_pack_UOM_desc,
            "PRIMARY_PACK_QTY": pur.primary_pack_quantity,
			"TOTAL_PRICE": pur.total_price,
			"SHIPPING_ADDRESS_ID": pur.shipping_address_id,
			"SHIP_DEA_NUMBER": pur.ship_DEA_number,
			"SHIP_FIRST_NAME": pur.ship_first_name,
			"SHIP_ADDRESS1": `${pur.ship_address1 || ''}`,
			"SHIP_COUNTRY_CODE": `${pur.ship_country_code || ''}`,
			"SHIP_STATE_CODE": `${pur.ship_state_code || ''}`,
			"SHIP_CITY_NAME": `${pur.ship_city_name|| ''}`,
			"SHIP_ZIP_CODE": `${pur.ship_zip_code || ''}`,
            "SHIP_DATE": $filter("date")(pur.ship_date, "MM/dd/yyyy"),
            "CREATED_BY": `${pur.created_by}`,
			"LOTS": `${pur.lots}`
		}));


		//----------Grid Function-----------------------------------------------------------------------------------------------------------------------------------------------   
		$ctrl.formatAddress = report => {
			return (report.ship_address1 ? `${report.ship_address1}` : '') + `&nbsp;` + (report.ship_address2 ? `${report.ship_address2}` : '') + `<br>` +
				(report.ship_country_code ? `${report.ship_country_code}` : '') + `&nbsp;` + (report.ship_state_code ? `${report.ship_state_code}` : '') +
				`&nbsp;` + (report.ship_zip_code ? `${report.ship_zip_code}` : '');
		};

	
    

        //DATEPICKER FUNCTION
        $ctrl.toggles = [];
        $ctrl.toggleDatePicker = function (toggle) {
            $ctrl.toggles[toggle] = !$ctrl.toggles[toggle];
        };
        const tenYearsAgo = new Date();
        tenYearsAgo.setYear(tenYearsAgo.getFullYear() - 10);

        $ctrl.fromDatePickerOptions = {
            'show-weeks': false,
            minDate: tenYearsAgo
        };

        $ctrl.endDatePickerOptions = {
            'show-weeks': false,
            minDate: tenYearsAgo
		};

		$ctrl.datesAreInvalid = () => {
			return moment($ctrl.selected.ship_from_date).isAfter($ctrl.selected.ship_to_date, 'day');
		}
		
    }
    controller.$inject = ["$window", "$scope", "$http", "$filter", "sessionService", "stToastFactory", "$q", "addressService", "reportService"];

})()